import React from 'react';

import { useLocation, useParams } from "react-router-dom";
import { useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux'

import pageWithSideMenu from '../../containers/pageWithSideMenu'
import pageContent from '../../containers/pageContent'

import dashboardAPICall from '../../app/apiCalls/dashboardAPICall'
import { mb_dashboard_offers } from "../../app/apiEndpoints"
import DataTable from "../../containers/DataTable";
import CardHeader from '../../containers/CardHeader'
import { Breadcrumb, Card } from 'react-bootstrap'
import { tableTypes } from "../../app/settings";
import InvalidPermissions from '../../containers/InvalidPermissions'
import ContentNotFound from '../../containers/ContentNotFound'

import Moment from 'moment';
import MediaBuyOptions from "./MediaBuyOptions";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const MediaBuyPlacementView = (props) => {
    let query = useQuery();
    const isSysadmin = useSelector((state) => state.user.isSysadmin)

    const [placement, setPlacement] = useState({})
    const [data, setData] = useState([])
    const [voluum, setVoluum] = useState("")
    const [totals, setTotals] = useState({})
    let { apiURI, placementURI } = useParams();
    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)
    const startDate = query.get("startDate")
    const endDate = query.get("endDate") 
    const [dataLoaded, setDataLoaded] = useState(false)
    const [hasError, setHasError] = useState(false)

    useEffect(() => {
        const getDetails = async () => {
            if(placementURI.length > 0) {
                const data = await dashboardAPICall(mb_dashboard_offers, 
                    {'placeURI': placementURI, 
                        'apiURI': apiURI,
                        'requester': userID, 
                        'company': companyID, 
                        'startDate': startDate || (Moment().format('MM/DD/YYYY')), 
                        'endDate': endDate || (Moment().format('MM/DD/YYYY'))
                    })
                if(data.placement) {
                    setPlacement(data.placement) 
                    if(data.data) {
                        setData(data.data)
                    }
                    if(data.voluum) {
                        setVoluum(data.voluum)
                    }
                    if(data.totals) {
                        setTotals(data.totals)
                    }
                }
                else if(data.error) {
                    setHasError(true)
                }
                setDataLoaded(true)
            }
        }
        if(!dataLoaded)
            getDetails()
    }, [placementURI, apiURI, userID, companyID, startDate, endDate, dataLoaded])

    const tableFields = () => {
        console.log("dash fields")
        if(data.length === 0) return []
        const row = data[0]
        const fields = Object.keys(row).map((field) => field)
        console.table(fields)
        return fields
    }

    const tableData = () => {
        console.log("dash data")
        if(data.length === 0) return []
        const dataRows = []
        data.forEach((row, i) => {
            const values = []
            Object.keys(row).forEach((field) => values.push(row[field]))
            dataRows.push({'id': i, 'values': values});
        });
        return dataRows
    }

    const csvData = () => {
        if(data.length === 0) return []
        const dataRows = []
        dataRows.push(tableFields())
        data.forEach((row, i) => {
            const values = []
            Object.keys(row).forEach((field) => values.push(row[field]))
            dataRows.push(values);
        });
        return dataRows
    }

    const csvFileName = () => {
        if(placement.placement_name.length === 0) return "Placement"
        return `${placement.placement_name.replaceAll(" ", "_")}_${placement.api_name.replaceAll(" ", "_")}.csv`
    }
    
    if(!isSysadmin)
        return <InvalidPermissions />

    if(hasError) 
        return <ContentNotFound contentType="Dashboard" />


    return (
        <>
        <Breadcrumb>
          <Breadcrumb.Item href="/mediabuy/">Media Buying Dashboard</Breadcrumb.Item>
          <Breadcrumb.Item href={`/mediabuy/${apiURI}/`}>{placement.api_name}</Breadcrumb.Item>
          <Breadcrumb.Item active>{placement.placement_name}</Breadcrumb.Item>
        </Breadcrumb>
        <Card>
            <CardHeader title={placement ? `${placement.placement_name} (${voluum})` : 'Loading...'} description={`Offers for ${placement.placement_name} under ${placement.api_name}`} />
            {data?.length > 0 ?
            <>
            <Card.Body>
            <MediaBuyOptions 
                startDate={startDate || (Moment().format('MM/DD/YYYY'))}
                endDate={endDate || (Moment().format('MM/DD/YYYY'))}
                formAction={`/mediabuy/${apiURI}/placement/${placementURI}`}
                csvData={csvData()}
                csvFileName={csvFileName()} />
            </Card.Body>
            <DataTable 
                tableID={placement.placement_name} 
                fieldNames={tableFields()} 
                dataRows={tableData()} 
                tableSettings={tableTypes.None} 
                totals={totals}
                />
            </>
            : <></>}
            {!dataLoaded ? <Card.Body>Loading dashboard...</Card.Body> : <></>}
        </Card>
        </>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContent(MediaBuyPlacementView), "Placement View"));
